import React from 'react';
import TagsInput from './tagsinput';

const inputFieldStyle = {
    marginLeft: 8,
    marginRight: 8,
    width: '95%',
    marginTop: '14px',
};

const inputFieldFullWidthStyle = {
    width: '100%',
    marginLeft: 0,
    marginRight: 0,
};

export default function EmailInput(props) {
    return (
        <TagsInput
            selectedTags={(items) => props.onChange(items.join(';'))}
            fullWidth
            variant="standard"
            id="emailinput"
            name={props.domElemName}
            label={props.label}
            tags={props.emails && props.emails.length > 0 ? props.emails.split(';') : []}
            style={{ ...inputFieldStyle, ...(props.fullWidth ? inputFieldFullWidthStyle : {}) }}
            hint={props.hint}
        />
    );
}
